import SimpleCrudList from '../../components/crud/SimpleCrudList';
import { siteLabel, type WebsitePageRecord } from './websitePageTypes';

export default function WebsitePages() {
  return (
    <SimpleCrudList<WebsitePageRecord>
      title="Website Pages"
      apiPath="/website-pages"
      baseRoute="/website-pages"
      description="Manage marketing and legal page content for each brand site. Sites load published pages from the API."
      searchKeys={['siteKey', 'slug', 'title', 'contentType']}
      columns={[
        {
          key: 'siteKey',
          label: 'Site',
          render: (r) => siteLabel(r.siteKey),
        },
        { key: 'slug', label: 'Slug' },
        { key: 'title', label: 'Title' },
        { key: 'contentType', label: 'Type' },
        {
          key: 'published',
          label: 'Published',
          render: (r) => (r.published ? 'Yes' : 'No'),
        },
      ]}
    />
  );
}
